var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('clip-loader',{attrs:{"loading":_vm.loader.isLoading,"color":_vm.loader.spinnerColor,"size":_vm.loader.spinnerSize}}),_c('h2',{staticClass:"heading"},[_vm._v("Loading")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }